import ReactGA from 'react-ga'
import posthog from 'posthog-js'

import { LOCALSTORAGE_TOKENS, USER_ROLES, gaDimensions } from '../constants'
import { guarantorDistinctId, userDistinctId } from './posthogIdentity'

/**
 * Resolve os papéis (papel_usuario) como array de strings.
 * O papel é marcado explicitamente conforme a tela/fluxo de entrada
 * (['aluno'] no login principal, ['avalista'] no provi-sign).
 * Fallback: ['aluno'].
 *
 * @param {string[]} [roles]
 * @returns {string[]}
 */
const resolveRoles = roles => {
  if (Array.isArray(roles) && roles.length) return roles

  return [USER_ROLES.aluno]
}

export const identify = ({ CreditRequestId, UserId, email, partnerSlug }) => {
  window.smartlook &&
    window.smartlook('identify', UserId, {
      CreditRequestId,
      UserId,
      email
    })

  // eslint-disable-next-line import/no-named-as-default-member
  ReactGA.set({
    [gaDimensions.userId]: UserId,
    [gaDimensions.partnerSlug]: partnerSlug,
    [gaDimensions.creditRequestId]: CreditRequestId
  })

  // O posthog.identify (person) NÃO roda aqui: este identify() é disparado a cada
  // navegação (history.listen) e no boot. O person identify roda apenas na primeira
  // entrada na aplicação, via identifyPerson() no validate-token.
  // O parceiro (partnerId/partnerName) é registrado como super property no
  // selectCrid, onde o PartnerId é obtido via getPartnerInfo.
}

/**
 * posthog.identify (person): deve ser chamado apenas na PRIMEIRA entrada na
 * aplicação (validate-token / provi-sign), não a cada navegação.
 *
 * O distinct_id tem namespace (ver ./posthogIdentity): aluno vira `ppay:<UserId>`;
 * avalista (GuarantorId presente) vira `ppay-avalista:<GuarantorId>`. O UserId que
 * chega no fluxo do avalista é o do ALUNO dono do pedido: usá-lo juntava as duas pessoas.
 *
 * @param {{ CreditRequestId?: number|string, UserId?: number|string, GuarantorId?: number|string, email: string, roles?: string[] }} payload
 */
export const identifyPerson = ({ CreditRequestId, UserId, GuarantorId, email, roles }) => {
  const isGuarantor = GuarantorId !== null && GuarantorId !== undefined && GuarantorId !== ''
  const distinctId = isGuarantor ? guarantorDistinctId(GuarantorId) : userDistinctId(UserId)
  if (!distinctId) return

  // Nome é persistido no localStorage durante a validação do token (validate-token).
  const name = localStorage.getItem(LOCALSTORAGE_TOKENS.name) || undefined
  const personProperties = {
    papel_usuario: resolveRoles(roles),
    email,
    crid: CreditRequestId
  }
  if (isGuarantor) {
    personProperties.avalista_id = String(GuarantorId)
  } else {
    personProperties.principiapay_id = String(UserId)
  }
  if (name) personProperties.name = name

  posthog.identify(distinctId, personProperties)
}

const getStoredIdentity = () => {
  const UserId = localStorage.getItem(LOCALSTORAGE_TOKENS.userId)
  const email = localStorage.getItem(LOCALSTORAGE_TOKENS.email)
  const partnerSlug = localStorage.getItem(LOCALSTORAGE_TOKENS.partnerSlug)

  return {
    UserId,
    email,
    partnerSlug
  }
}

export const identifyFromStoredIdentity = () => {
  const payload = getStoredIdentity()
  identify(payload)
}
